import { webAdapter } from "@/lib/adapters/web";
import { macAdapter } from "@/lib/adapters/mac";

// Resolve edition: URL ?edition=mac wins, then saved preference, else web.
export function resolveEdition() {
  if (typeof window === "undefined") return "web";
  const q = new URLSearchParams(window.location.search).get("edition");
  if (q === "mac" || q === "web") return q;
  const saved = localStorage.getItem("rs_edition");
  return saved === "mac" ? "mac" : "web";
}

export function getAdapter(edition) {
  return edition === "mac" ? macAdapter : webAdapter;
}
